angular.module('core')
  .controller('EngagementCertificateModalController', [
      '$scope',
      '$window',
      '$modalInstance',
      'dblActivity',
      'studentName',
      function ($scope,
                $window,
                $modalInstance,
                dblActivity,
                studentName) {
          $scope.dblActivity = dblActivity;
          $scope.studentName = studentName;
          $scope.loadingModal = false;
      }]);
